import { __decorate } from "tslib";
import { Vue, Component, Mixins, Prop } from "vue-property-decorator";
import { uiMapper } from "@/services/store/modules/ui/store";
import { dataMapper } from "@/services/store/modules/data/store";
import Swiper from "swiper";
import IconSvg from "@/components/IconSvg.vue";
const UiMappers = Vue.extend({
    computed: {
        ...uiMapper.mapState(["breakpoint"]),
    },
});
const DataMappers = Vue.extend({
    computed: {
        ...dataMapper.mapState(["instagram"]),
    },
    methods: {},
});
let GalleryMain = class GalleryMain extends Mixins(UiMappers, DataMappers) {
    constructor() {
        super(...arguments);
        this.swiper = null;
    }
    get isSm() {
        return this.breakpoint === "sm";
    }
    get isXs() {
        return this.breakpoint === "xs";
    }
    get slidesPerView() {
        if (this.fixedItemsPerRow) {
            return this.fixedItemsPerRow;
        }
        if (this.isSm) {
            return 2;
        }
        if (this.isXs) {
            return 1;
        }
        return 3;
    }
    async created() {
        window.addEventListener("resize", async () => {
            this.destroySwiper();
            await this.$nextTick();
            this.initSwiper();
        });
    }
    async mounted() {
        await this.$nextTick();
        this.initSwiper();
    }
    beforeDestroy() {
        this.destroySwiper();
    }
    initSwiper() {
        const container = document.getElementById(this.swiperId);
        if (!container)
            return;
        this.swiper = new Swiper(container, {
            spaceBetween: 30,
            slidesPerView: this.slidesPerView,
            // slidesOffsetBefore: 50,
            // slidesOffsetAfter: 50,
            // centeredSlides: true,
            loop: true,
            autoplay: this.autoplay,
            navigation: {
                nextEl: `#btn-next-${this.swiperId}`,
                prevEl: `#btn-prev-${this.swiperId}`,
            },
        });
    }
    destroySwiper() {
        if (this.swiper) {
            this.swiper.destroy();
            this.swiper = null;
        }
    }
};
__decorate([
    Prop()
], GalleryMain.prototype, "swiperId", void 0);
__decorate([
    Prop()
], GalleryMain.prototype, "images", void 0);
__decorate([
    Prop()
], GalleryMain.prototype, "autoplay", void 0);
__decorate([
    Prop()
], GalleryMain.prototype, "fixedItemsPerRow", void 0);
GalleryMain = __decorate([
    Component({
        components: {
            IconSvg,
        },
    })
], GalleryMain);
export default GalleryMain;
